import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2825a28f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "password-page" }
const _hoisted_2 = { class: "password-page__form-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "password-page__title" }, "Set new password", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "password-page__desc" }, [
  /*#__PURE__*/_createTextVNode("Should have: "),
  /*#__PURE__*/_createElementVNode("ul", { class: "password-page__list" }, [
    /*#__PURE__*/_createElementVNode("li", null, "at least one lowercase letter"),
    /*#__PURE__*/_createElementVNode("li", null, "at least one uppercase letter"),
    /*#__PURE__*/_createElementVNode("li", null, "at least one digit"),
    /*#__PURE__*/_createElementVNode("li", null, "at least one non alphanumeric character from ?!@#$%^&*"),
    /*#__PURE__*/_createElementVNode("li", null, "minimum length of 6")
  ])
], -1))
const _hoisted_5 = { class: "password-page__form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Password", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Confirm password", -1))
const _hoisted_8 = {
  key: 0,
  class: "password-page__error"
}
const _hoisted_9 = {
  key: 1,
  class: "password-page__error"
}
const _hoisted_10 = { class: "password-page__form-buttons" }
const _hoisted_11 = {
  key: 1,
  class: "password-page__title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.passwordSet)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("form", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "password",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
                required: "",
                onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearErrors && _ctx.clearErrors(...args)))
              }, null, 544), [
                [_vModelText, _ctx.password]
              ]),
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "password",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passwordConfirm) = $event)),
                required: "",
                onKeyup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearErrors && _ctx.clearErrors(...args)))
              }, null, 544), [
                [_vModelText, _ctx.passwordConfirm]
              ]),
              (!_ctx.passwordRegValid)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Password does not meet requirements"))
                : _createCommentVNode("", true),
              (!_ctx.passwordMatchValid)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Passwords not matching"))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "button button--big button--green",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmCred && _ctx.confirmCred(...args)), ["prevent"]))
                }, "Set password")
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.passwordSet)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_11, "New password set succesfully!"))
        : _createCommentVNode("", true)
    ])
  ]))
}